import React from 'react';
import { PropTypes } from 'prop-types';
import { P, Container, Title } from './styles';

const STATES = {
    1: 'California',
    2: 'Massachusetts',
    3: 'New Jersey',
    4: 'New York',
    5: 'Florida',
};

const Footer = ({
    firstName,
    lastName,
    companyName,
    projectName,
    position,
    email,
    projectStreet,
    projectStreet2,
    projectCity,
    projectState,
    projectZip,
    token,
}) => (
    <Container>
        {companyName ? <Title>{companyName} - {projectName}</Title>
            : <Title>{projectName}</Title>
        }

        <P>
            {firstName} {lastName}, {position} - {email}
        </P>

        <P>
            {projectStreet} {projectStreet2}<br />
            {projectCity}, {STATES[projectState] || '???'}, {projectZip}
        </P>

        <P>
            Public Token: {token}
        </P>

        <P>
            For questions reach out directly to your sales representative
            or email questions to info@acdcsolar.com.
        </P>
    </Container>
);

Footer.propTypes = {
    companyName: PropTypes.string.isRequired,
    projectName: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    projectStreet: PropTypes.string.isRequired,
    projectStreet2: PropTypes.string.isRequired,
    projectCity: PropTypes.string.isRequired,
    projectZip: PropTypes.string.isRequired,
    projectState: PropTypes.number.isRequired,
};

Footer.defaultProps = {

};

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/Simulator/Footer/Footer.js